import { fetchGlobalPricingId } from 'server/utils/fetchGlobalPricingId';
import { GOAT_CLEAN_HEADER_DATA, PAGE_DESCRIPTION } from 'goat-clean/enums/goatCleanEnums';
import { IProductLandingPage } from 'shared/types/ProductLandingPage';
import { PlpPageComponent as PLPLandingPageComponent } from 'product-landing-pages/components/PlpPageComponent';
import { getBrowseResults } from 'server/utils/constructor/getBrowseResults';
import { isSearchCrawler } from 'shared/utils/isSearchCrawler';
import { t } from 'localization/utils/t';
import { setServerSideTranslations } from 'localization/utils/setServerSideTranslations';
import { getTranslations } from 'shared/utils/getTranslations';

const TP = 'pages.goatClean.index';

const GoatClean = ({
  browseKey,
  browseValue,
  constructorResponse,
  displayName,
  globalPricingId,
  isCrawler = false,
}: IProductLandingPage) => {
  const pageDescription = getTranslations(PAGE_DESCRIPTION);
  const goatCleanHeaderData = getTranslations(GOAT_CLEAN_HEADER_DATA);
  return (
    <PLPLandingPageComponent
      breadcrumbs={[
        { name: t(`${TP}.breadcrumbSneakers`, 'Sneakers'), slug: `/sneakers` },
        { name: t(`${TP}.breadcrumbGoatClean`, 'Goat Clean'), slug: `/goat-clean`, isStatic: true },
      ]}
      browseKey={browseKey}
      browseValue={browseValue}
      constructorResponse={constructorResponse}
      displayName={displayName}
      globalPricingId={globalPricingId}
      metadataDescription={pageDescription}
      isCrawler={isCrawler}
      {...goatCleanHeaderData}
    />
  );
};

export const getServerSideProps = async ({ query, resolvedUrl, req, res, locale }) => {
  const globalPricingId = await fetchGlobalPricingId({ req, res });
  const isCrawler = isSearchCrawler(req?.headers);

  try {
    const browseResponse = await getBrowseResults({
      req,
      res,
      resolvedUrl,
      query,
      filterKey: 'group_id',
      filterValue: 'all',
    });

    const invalidSearch = browseResponse.response.total_num_results === 0;

    if (invalidSearch) {
      return {
        notFound: true,
      };
    }

    return {
      props: {
        ...(await setServerSideTranslations({ locale })),
        browseKey: 'group_id',
        browseValue: 'all',
        constructorResponse: browseResponse,
        displayName: 'GOAT Clean',
        globalPricingId,
        isCrawler,
      },
    };
  } catch {
    return { notFound: true };
  }
};

export default GoatClean;
